const BASE_URL = 'https://api.maptiler.com';
const API_KEY = 'vbXhrAvJzMU6eGn6kTxi';
const MAP_STYLE = 'bright-v2';

export const MAP_URLS = {
  STREET: `${BASE_URL}/maps/${MAP_STYLE}/{z}/{x}/{y}.png?key=${API_KEY}`,
  SATELLITE: `${BASE_URL}/maps/hybrid/{z}/{x}/{y}.jpg?key=${API_KEY}`,
};
